import React from 'react'
import styled from 'styled-components'
import { Row } from 'components/common/layout'
import { BaseText, SemiBoldText } from 'components/common/text'
import { StartupMember } from 'types/common'
import { Card } from 'components/common/card'

export const TeamMember: React.FC<{
  data: StartupMember
  backgroundColor?: string
}> = ({ data, backgroundColor }) => (
  <MemberCard backgroundColor={backgroundColor}>
    <Row style={{ gap: 8 }}>
      <MemberTitle>
        {data.name} {data.role}
      </MemberTitle>
    </Row>
    <MemberDesc>{data.intro}</MemberDesc>
  </MemberCard>
)

const MemberCard = styled(Card)<{ backgroundColor?: string }>`
  gap: 12px;
  padding: 16px;
  border-radius: 12px;
  background-color: ${(p) => p.backgroundColor || p.theme.color.white1};
`

const MemberTitle = styled(SemiBoldText)`
  font-size: ${(p) => p.theme.fontSize.desc};
`

const MemberDesc = styled(BaseText)`
  line-height: 1.8;
`
